var _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMiddleBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 18,
    viewBox: "0 0 137 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 137,
    height: 18,
    rx: 9,
    fill: "white",
    fillOpacity: 0.0712686
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.35,
    y: 0.35,
    width: 137,
    height: 17.3,
    rx: 8.65,
    stroke: "white",
    strokeOpacity: 0.11268,
    strokeWidth: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiddleBg);
export default __webpack_public_path__ + "static/media/middle_bg.0fbf0f84ddd9ebd4fc748a6c9fd7295e.svg";
export { ForwardRef as ReactComponent };